function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 62 62"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 12.6s-.3-.7-1.3-1.3c-1 .6-1.3 1.3-1.3 1.3-10.1.7-18.1 9.1-18.1 19.4 2.3 0 4.2-1.4 6.5-1.4s4.2 1.4 6.5 1.4 4.2-1.4 6.5-1.4 4.2 1.4 6.5 1.4 4.2-1.4 6.5-1.4 4.2 1.4 6.5 1.4c-.1-10.3-8.1-18.7-18.3-19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 46V31.9c-2.6 0-4 .8-4 2.7v12.1c0 2.9 1.8 4.6 4.7 4.6 1.2 0 1.9-.2 2.3-.4v-3.3c-.2.1-.8.1-1.2.1-1.2 0-1.8-.4-1.8-1.7z"
  }));
};
function CircularProgressWithLogo(props) {
  var color = props.color;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: "relative",
      display: "inline-flex"
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, props), /*#__PURE__*/React.createElement(Box, {
    sx: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(SvgComponent, {
    fill: theme.palette[color || "primary"].main,
    stroke: theme.palette[color || "primary"].main
  })));
}
export default CircularProgressWithLogo;